module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('div', {
    staticClass: "fade-transition ng-scope",
    attrs: {
      "ng-view": ""
    }
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("Entidades")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": _vm.breadcrumb
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [((_vm.historico_atualizado.length > 0 && _vm.historico_atualizado[0] && _vm.historico_atualizado[0].termino == null && _vm.historico_atualizado[1].observacao != null && _vm.historico_atualizado[1].observacao != '')) ? _c('div', {
    staticClass: "alert alert-dismissible alert-info"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.show.info = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h5', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.historico_atualizado[1].observacao)
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ng-scope ng-isolate-scope",
    attrs: {
      "ng-if": "show.grid"
    }
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Validação da Entidade    "), _c('a', {
    attrs: {
      "href": _vm.urlLaravel + '/docs/manual_cadastro_entidade_dirigentes_usuarios_v1.pdf',
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Manual")])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.boqueia === true
    }
  }, [_c('div', {
    staticClass: "box-body",
    attrs: {
      "id": "dadosCadastrais"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "frmCommonRegister",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "col-md-7 col-lg-6",
    attrs: {
      "id": "cadastroJuri"
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": !_vm.isEditable() || _vm.boqueia === true
    }
  }, [_c('legend', [_vm._v("Dados da entidade:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Razão social')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Razão social"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'ds_nome')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": 'Conteúdo anterior: ' + _vm.diferenca.ds_nome
    }
  }) : _vm._e(), _vm._v("\n                          Razão social:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.ds_nome),
      expression: "entidade.ds_nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:255'),
      expression: "'required|min:1|max:255'"
    }],
    ref: "ds_nome",
    staticClass: "form-control",
    attrs: {
      "name": "Razão social",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entidade.ds_nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade, "ds_nome", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Razão social')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Razão Social é obrigatório')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.first('CNPJ')
    }
  }, [_c('label', {
    ref: "CNPJ",
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "CNPJ"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'ds_cnpj')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": 'Conteúdo anterior: ' + _vm.diferenca.ds_cnpj
    }
  }) : _vm._e(), _vm._v("\n                          CNPJ:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:14|max:14'),
      expression: "'required|min:14|max:14'"
    }],
    ref: "ds_cnpj",
    staticClass: "form-control",
    attrs: {
      "name": "CNPJ",
      "type": "text",
      "mask": "NN.NNN.NNN/NNNN-##",
      "tokens": _vm.$cnpjTokens,
      "disabled": "true"
    },
    model: {
      value: (_vm.entidade.ds_cnpj),
      callback: function($$v) {
        _vm.$set(_vm.entidade, "ds_cnpj", $$v)
      },
      expression: "entidade.ds_cnpj"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('CNPJ')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo CNPJ é obrigatório')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('cnpjExpeditionTime')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "cnpjExpeditionTime"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'dt_data_expedicao_cnpj')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": _vm._f("moment")('Conteúdo anterior: ' + _vm.diferenca.dt_data_expedicao_cnpj, 'L')
    }
  }) : _vm._e(), _vm._v("\n                          Expedição CNPJ:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dt_data_expedicao_cnpj),
      expression: "dt_data_expedicao_cnpj"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validdate|dateeqpast'),
      expression: "'required|validdate|dateeqpast'"
    }],
    ref: "cnpjExpeditionTime",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "cnpjExpeditionTime",
      "data-vv-as": "Expedição CNPJ",
      "masked": _vm.masked
    },
    domProps: {
      "value": (_vm.dt_data_expedicao_cnpj)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dt_data_expedicao_cnpj = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('cnpjExpeditionTime')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Expedição do CNPJ é obrigatório')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Nome fantasia')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Nome fantasia"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'ds_nome_fantasia')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": 'Conteúdo anterior: ' + _vm.diferenca.ds_nome_fantasia
    }
  }) : _vm._e(), _vm._v("\n                          Nome fantasia:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.ds_nome_fantasia),
      expression: "entidade.ds_nome_fantasia"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:255'),
      expression: "'required|min:1|max:255'"
    }],
    ref: "ds_nome_fantasia",
    staticClass: "form-control",
    attrs: {
      "name": "Nome fantasia",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entidade.ds_nome_fantasia)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade, "ds_nome_fantasia", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Nome fantasia')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Nome fantasia é obrigatório')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Natureza jurídica')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "forma_jurídica"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'forma_juridica') && _vm.diferenca.forma_juridica) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": 'Conteúdo anterior: ' + _vm.diferenca.forma_juridica.descricao
    }
  }) : _vm._e(), _vm._v("\n                          Natureza jurídica: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.listaFormasJuridicas,
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": true,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": "Selecione uma Natureza Jurídica",
      "track-by": "codigo",
      "custom-label": _vm.etiquetaListaFormaJuridica,
      "preselect-first": false,
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "Selecionado",
      "name": "forma_juridica"
    },
    model: {
      value: (_vm.entidade.forma_juridica),
      callback: function($$v) {
        _vm.$set(_vm.entidade, "forma_juridica", $$v)
      },
      expression: "entidade.forma_juridica"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.errors.first('Natureza jurídica')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Natureza jurídica')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Ramo atividade')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Ramo atividade"
    }
  }, [(_vm.inclRamo && _vm.naoExisteRamo === false) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_insercao",
    attrs: {
      "title": 'Inclusões: ' + _vm.inclRamoTexto
    }
  }) : _vm._e(), _vm._v(" "), (_vm.exclRamo && _vm.exclRamo.length > 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_exclusao"
  }) : _vm._e(), _vm._v("\n                          Ramos de Atividade: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.listaRamosAtividade,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": true,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": "Selecione os Ramos de Atividade",
      "label": "ds_codigo",
      "track-by": "ds_codigo",
      "custom-label": _vm.etiquetaListaRamosAtividade,
      "selectedLabel": "Selecionado",
      "selectLabel": "Aperte ENTER para selecionar",
      "deselectLabel": "Aperte ENTER para remover",
      "name": "ramos_atividade",
      "options-limit": 1500
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', {
          staticClass: "multiselect__tag"
        }, [_c('span', [_vm._v(_vm._s(props.ds_codigo))]), _c('span', {
          staticClass: "custom__remove",
          on: {
            "click": function($event) {
              return props.remove(props)
            }
          }
        }, [_vm._v("❌")])])]
      }
    }]),
    model: {
      value: (_vm.entidade.ramos_atividade),
      callback: function($$v) {
        _vm.$set(_vm.entidade, "ramos_atividade", $$v)
      },
      expression: "entidade.ramos_atividade"
    }
  }, [_vm._v(" "), _c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.errors.first('Ramo atividade')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Ramo atividade')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Doc. constituição')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "constitutionDocument"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'documento_constituicao') && _vm.diferenca.documento_constituicao) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": 'Conteúdo anterior: ' + _vm.diferenca.documento_constituicao.ds_tipo
    }
  }) : _vm._e(), _vm._v("\n                          Documento de constituição:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.listaDocConstituicao,
      "multiple": false,
      "close-on-select": true,
      "track-by": "id",
      "label": "ds_tipo",
      "placeholder": "Selecione um Documento de constituição",
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "Selecionado",
      "name": "listaDocConstituicao"
    },
    model: {
      value: (_vm.entidade.documento_constituicao),
      callback: function($$v) {
        _vm.$set(_vm.entidade, "documento_constituicao", $$v)
      },
      expression: "entidade.documento_constituicao"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('Doc. constituição')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Doc. constituição é obrigatório')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-lg-6",
    attrs: {
      "id": "contato"
    }
  }, [_c('fieldset', [_c('legend', [_vm._v("Contato:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Telefone')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Telefone"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'contato.ds_telefone') && _vm.diferenca.contato) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": 'Conteúdo anterior: ' + _vm.diferenca.contato.ds_telefone
    }
  }) : _vm._e(), _vm._v("\n                          Telefone:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:10|max:11'),
      expression: "'required|min:10|max:11'"
    }],
    ref: "Telefone",
    staticClass: "form-control",
    attrs: {
      "name": "Telefone",
      "data-vv-as": "Telefone",
      "type": "text",
      "masked": false,
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.entidade.contato.ds_telefone),
      callback: function($$v) {
        _vm.$set(_vm.entidade.contato, "ds_telefone", $$v)
      },
      expression: "entidade.contato.ds_telefone"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "mobile"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'contato.ds_celular') && _vm.diferenca.contato) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": 'Conteúdo anterior: ' + _vm.diferenca.contato.ds_celular
    }
  }) : _vm._e(), _vm._v("\n                          Celular:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-lg-4"
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:10|max:11'),
      expression: "'min:10|max:11'"
    }],
    ref: "mobile",
    staticClass: "form-control",
    attrs: {
      "name": "mobile",
      "data-vv-as": "Celular",
      "type": "text",
      "masked": false,
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.entidade.contato.ds_celular),
      callback: function($$v) {
        _vm.$set(_vm.entidade.contato, "ds_celular", $$v)
      },
      expression: "entidade.contato.ds_celular"
    }
  }), _vm._v(" "), (_vm.errors.first('mobile')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('mobile')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Email')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "email"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'ds_email')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": 'Conteúdo anterior: ' + _vm.diferenca.ds_email
    }
  }) : _vm._e(), _vm._v("\n                          E-Mail:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.ds_email),
      expression: "entidade.ds_email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:255'),
      expression: "'required|min:1|max:255'"
    }],
    ref: "ds_email",
    staticClass: "form-control",
    attrs: {
      "name": "Email",
      "type": "text",
      "delivery": "account",
      "method": "uniqueUserEmail"
    },
    domProps: {
      "value": (_vm.entidade.ds_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade, "ds_email", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Email')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo E-mail é obrigatório')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "email"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'ds_website')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": 'Conteúdo anterior: ' + _vm.diferenca.ds_website
    }
  }) : _vm._e(), _vm._v("\n                          Site:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.ds_website),
      expression: "entidade.ds_website"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:255'),
      expression: "'max:255'"
    }],
    ref: "ds_website",
    staticClass: "form-control",
    attrs: {
      "name": "website",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entidade.ds_website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade, "ds_website", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "possuiCebas"
    }
  }, [_vm._v("Possui CEBAS:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.possuiCebas),
      expression: "possuiCebas"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "possuiCebas",
      "disabled": true
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.possuiCebas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("Não")]), _vm._v(" "), _c('option', [_vm._v("Sim")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "possuiCmas"
    }
  }, [_vm._v("Possui CMAS/CAS:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.possuiCmas),
      expression: "possuiCmas"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "possuiCmas",
      "disabled": true
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.possuiCmas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("Não")]), _vm._v(" "), _c('option', [_vm._v("Sim")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(2), _vm._v(" "), _c('endereco', {
    attrs: {
      "entEnderecos": _vm.entidade.endereco,
      "mudaEndereco": _vm.mudancas,
      "analise": _vm.analise,
      "revisao": _vm.revisao,
      "diferenca": _vm.diferenca
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(3), _vm._v(" "), _c('dirigentes', {
    attrs: {
      "entDirigentes": _vm.entidade.dirigentes,
      "entidadeParceira": _vm.entidade,
      "componenteSuperior": _vm.componenteSuperior,
      "mudaDirigente": _vm.mudancas,
      "analise": _vm.analise,
      "revisao": _vm.revisao,
      "diferenca": _vm.diferenca,
      "name": "dirigentes"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(4), _vm._v(" "), _c('usuarios', {
    attrs: {
      "entUsuarios": _vm.entidade.usuarios,
      "mudaUsuario": _vm.mudancas,
      "componenteSuperior": _vm.componenteSuperior,
      "analise": _vm.analise,
      "revisao": _vm.revisao,
      "diferenca": _vm.diferenca
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('upload-documentos-php-novo', {
    attrs: {
      "propDocumentos": _vm.entidade.documentos,
      "documentTypes": _vm.entidade.tipos_documento,
      "disable": '',
      "local-uso": 'CADASTRO_ENTIDADE',
      "mudaDocumento": _vm.mudancas,
      "analise": _vm.analise,
      "revisao": _vm.revisao,
      "diferenca": _vm.diferenca,
      "salvouOK": _vm.salvouOK
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('historico-entidade', {
    attrs: {
      "entHistorico": _vm.historico
    },
    on: {
      "historico_itens": function($event) {
        _vm.historico_atualizado = $event
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-12"
  }, [_c('legend', [_vm._v("Análise da entidade:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required full",
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "approvalResult"
    }
  }, [_vm._v("Decisões:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "radio-inline new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.resultadoAprovacao),
      expression: "entidade.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "resultado",
      "id": "resultado",
      "value": "Aprovar"
    },
    domProps: {
      "checked": _vm._q(_vm.entidade.resultadoAprovacao, "Aprovar")
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.entidade, "resultadoAprovacao", "Aprovar")
      }, _vm.limpaObs]
    }
  }), _vm._v(" Aprovar\n                          "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "radio-inline new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.resultadoAprovacao),
      expression: "entidade.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "resultado",
      "value": "Revisar"
    },
    domProps: {
      "checked": _vm._q(_vm.entidade.resultadoAprovacao, "Revisar")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.entidade, "resultadoAprovacao", "Revisar")
      }
    }
  }), _vm._v(" Devolver para ajustes\n                          "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "radio-inline new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.resultadoAprovacao),
      expression: "entidade.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "resultado",
      "value": "Cancelar"
    },
    domProps: {
      "checked": _vm._q(_vm.entidade.resultadoAprovacao, "Cancelar")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.entidade, "resultadoAprovacao", "Cancelar")
      }
    }
  }), _vm._v(" Cancelar Alteração\n                          "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), (_vm.entidade.resultadoAprovacao === 'Cancelar' || _vm.entidade.resultadoAprovacao === 'Revisar') ? _c('div', {
    staticClass: "form-group required full required-field",
    class: {
      'has-error': _vm.errors.first('justificativa')
    },
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "justificativa"
    }
  }, [_vm._v("Justificativa:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.observacao),
      expression: "entidade.observacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "name": "justificativa",
      "id": "justificativa"
    },
    domProps: {
      "value": (_vm.entidade.observacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade, "observacao", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()]) : _vm._e()])])])])])]), _vm._v(" "), (_vm.boqueia === false) ? _c('div', {
    staticClass: "box-footer"
  }, [_c('g-button-moema', {
    attrs: {
      "color": "success",
      "size": "button--size-ss",
      "disabled": !_vm.isEditable()
    },
    nativeOn: {
      "click": function($event) {
        return _vm.conclui(_vm.frmCommonRegister)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluir")]), _vm._v(" "), _c('g-button-moema', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salva(_vm.frmCommonRegister)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('g-button-moema', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar à lista")])], 1) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa fa-info"
  }), _vm._v("   Atenção!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 box-body"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "fa fa-warning indicador_alteracao"
  }), _c('label', {
    staticClass: "control-label"
  }, [_vm._v("  Dados alterados pela entidade")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "fa fa-warning indicador_insercao"
  }), _c('label', {
    staticClass: "control-label"
  }, [_vm._v("  Dados novos inseridos pela entidade")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "fa fa-warning indicador_exclusao"
  }), _c('label', {
    staticClass: "control-label"
  }, [_vm._v("  Dados excluídos pela entidade")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Endereço:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Dirigentes/Designados:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Usuários do sistema:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Documentos anexos:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Histórico:")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b4eeb62!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/validação/entidades/ValidaEntidades.vue
// module id = 1972
// module chunks = 1